import { render } from "./IndicatorsProducts.vue?vue&type=template&id=f97d2eb4&scoped=true"
import script from "./IndicatorsProducts.vue?vue&type=script&lang=js"
export * from "./IndicatorsProducts.vue?vue&type=script&lang=js"

import "./IndicatorsProducts.vue?vue&type=style&index=0&id=f97d2eb4&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f97d2eb4"]])

export default __exports__